
import { useContext } from "react";
import { HotelContext } from "states/hotelContext";

export const useHotelContext = () => {
  const context = useContext(HotelContext);

  if (!context) {
    throw new Error("useHotelContext must be used within a HotelProvider");
  }

  return context;
};
